(function (module) {
    'use strict';

    function NoPermission(Store, LoopBackAuth, $state) {
        this.clearCookies = () => {
            Store.setCurrentSubAccountId(null);

            LoopBackAuth.clearUser();
            LoopBackAuth.clearStorage();
            $state.go('login');
        };
    }

    function NoPermissionsConfig($stateProvider, $translatePartialLoaderProvider) {
        // Route
        $stateProvider.state('root.no-permissions', {
            url: '/no-permissions',
            data: {
                pageTitle: 'BLOCKED_ACCOUNT.PAGE_TITLE',
            },
            views: {
                'content@root': {
                    templateUrl: '/js/authentication/no-permissions/no-permissions.html',
                    controller: 'NoPermission as $ctrl',
                },
            },
            resolve: {
                currentUser: function (User) {
                    return User.getCurrent().$promise.then(function (response) {
                        return response;
                    });
                },
                account: function (currentUser, Account, $state) {
                    const accountId = currentUser.accountId;
                    Account.findById({ id: accountId }).$promise.then(function (response) {
                        return response;
                    });
                },
            },
            bodyClass: 'page--no-permissions',
        });

        // Translations
        $translatePartialLoaderProvider.addPart('/js/authentication/no-permissions');
    }

    module.config(NoPermissionsConfig).controller('NoPermission', NoPermission);
})(angular.module('rocket.components'));
